import React from 'react';
import ToplearnText from './ToplearnText';
import { View, StyleSheet, Image, Platform } from 'react-native';
import { numberWithCommas } from '../../utils/price';

const TblShow = ({
    mablaghKol,
    tarikhPardakht,
    shomarehPeygiri,
    bpdSepordeh,
    bpdAdi,
    bpdKargoshaie,
    bpdZarori,
    bpdKarmozdVam,
    bpdSodBanki,
    bpdKomak,
    bpdJrmDirkard,
    bpdTozihat,
    srdAdi,
    srdKargoshaie,
    srdZarori,
}) => {
    return (
        <View style={styles.tblShow}>
            <Image
                style={styles.imgProp}
                source={
                        bpdKarmozdVam !== 0
                        ? require('../../assets/info-sep.png')
                        : bpdKomak !== 0
                        ? require('../../assets/info-sep.png')
                        : bpdZarori !== 0
                        ? require('../../assets/Zarori.png')
                        : bpdKargoshaie !== 0
                        ? require('../../assets/Kargoshaie.png')
                        : require('../../assets/Sandogh.png')
                }
            />
            <View style={{ padding: 5}}>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        تاریخ پرداخت: {tarikhPardakht}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        شماره پیگیری: {shomarehPeygiri}
                    </ToplearnText>
                </View>

                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        ب.سپرده:{' '}
                        {bpdSepordeh === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdSepordeh)} ریال`}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        ب.عادی:{' '}
                        {bpdAdi === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdAdi)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        ب.کارگشایی:{' '}
                        {bpdKargoshaie === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdKargoshaie)} ریال`}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        ب.ضروری:{' '}
                        {bpdZarori === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdZarori)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        کارمزد وام:{' '}
                        {bpdKarmozdVam === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdKarmozdVam)} ریال`}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        جریمه دیرکرد:{' '}
                        {bpdJrmDirkard === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdJrmDirkard)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        سود بانکی:{' '}
                        {bpdSodBanki === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdSodBanki)} ریال`}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        کمک:{' '}
                        {bpdKomak === 0
                            ? ' -'
                            : ` ${numberWithCommas(bpdKomak)} ریال`}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        توضیحات: {bpdTozihat === 0 ? ' -' : bpdTozihat}
                    </ToplearnText>
                </View>
                <View style={styles.courseDetails}>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        سررسید: عادی{' '}
                        {srdAdi === 0
                            ? ' -'
                            : srdAdi}
                        {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        کارگشایی{' '}
                        {srdKargoshaie === 0
                            ? ' -'
                            :srdKargoshaie}
                                               {'   '}
                    </ToplearnText>
                    <ToplearnText fontFamily="yekan" size="1.5">
                        ضروری{' '}
                        {srdZarori === 0
                            ? ' -'
                            :srdZarori}
                    </ToplearnText>
                </View>
            </View>
            <ToplearnText fontFamily="yekan" size="1.8" color="red">
                {mablaghKol === 0
                    ? ' -'
                    : ` ${numberWithCommas(mablaghKol)} ریال`}
            </ToplearnText>
        </View>
    );
};

export default TblShow;

const styles = StyleSheet.create({
    tblShow: {
        alignSelf: 'center',
        borderRadius: 15,
        backgroundColor: 'white',
        marginBottom: 10,
        flexDirection: 'row',
        width: '95%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 5,
        justifyContent: 'space-evenly',
    },
    courseDetails: {
        flexDirection: 'row',
        //justifyContent: 'space-between',
    },
    imgProp: {
        width:Platform.OS === 'web' ? 40 : 30,
        height:Platform.OS === 'web' ? 40 : 30,
        resizeMode: 'contain',
    },
});
